import React, { useEffect, useState } from 'react';
import './MarkupInput.css';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import { customNumberHandleChange } from '../../utils/customOnChange';

const MarkupInput = ({ allDisabled, totalPrice }) => {
    const [isFocused, setIsFocused] = useState(false);
    const {
        values,
        setFieldValue,
        touched,
        errors
    } = useFormikContext();

    const hasError = touched?.price_markup && errors?.price_markup;
    const hasValue = values?.price_markup && values?.price_markup > 0;
    const isLabelFloating = isFocused || hasValue;

    useEffect(() => {
        if (!allDisabled) {
            const numericPrice = Number(totalPrice)
            const numericMarkup = Number(values?.price_markup)
            if (numericPrice && numericMarkup > 0 && numericMarkup > numericPrice) {
                const percentageAmount = ((numericMarkup - numericPrice) / numericPrice) * 100;
                setFieldValue("markup_percentage", Number(percentageAmount))
            } else {
                setFieldValue("markup_percentage", "")
            }
        }
    }, [allDisabled, values?.price_markup, totalPrice])

    return (
        <div className={`markup-input-container ${hasError ? 'has-error' : ''} ${allDisabled ? 'disabled' : ''}`}>
            <div className="input-wrapper">
                <div className="currency-prefix">
                    <span className="currency-symbol">INR</span>
                </div>
                <input
                    id="markup-input"
                    name="price_markup"
                    type="text"
                    className="markup-input"
                    disabled={allDisabled}
                    value={values?.price_markup?.toLocaleString("en-IN") || ''}
                    onChange={(e) => {
                        const val = e.target.value;
                        console.log(val , "valllllllllll")
                        setFieldValue("price_markup", customNumberHandleChange(val));
                    }}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    placeholder=" "
                />
                <label
                    htmlFor="markup-input"
                    className={`floating-label ${isLabelFloating ? 'floating' : ''}`}
                >
                    New Price
                </label>
                <div className="input-border"></div>
            </div>
            <ErrorMessage name="price_markup" component="div" className="error-message" />
        </div>
    );
};

export default MarkupInput;
